import { useContext } from "react";
import { PageMain } from "./p.main";
import { PageContext } from "../common/pages";
import { PageOrder } from "./p.order";
import { Box, Stack } from "@mui/material";
import { GREY } from "../style/theme";
import { useUser } from "../components/user";
import { PageNewPlayer } from "./p.player.new";
import { PageNewOrder } from "./p.order.new";
import { Order } from "../components/order";
import { Admin } from "../components/admin";
import { PageAdmin } from "./p.admin";
import { PlayerManaged, usePlayer } from "../components/player";
import { useExt } from "../components/ext";


export function Router(props) {
    const { path } = useContext(PageContext)

    if (path.length > 0) {
        if (path[0] === 'admin') {
            return <Admin><PageAdmin /></Admin>
        }
    }

    return <PlayerManaged>
        <RouterPlayer />
    </PlayerManaged>
}

function RouterPlayer(props) {
    const ext = useExt();
    const player = usePlayer();

    if (!player.name) {
        return <PageNewPlayer />
    }

    if (!ext.playerCheck(player)) {
        return ext.playerCheckModule(player);
    }

    if (!player.order) {
        return <PageNewOrder />
    }
    return <Order>
        <PageOrder />
    </Order>
}